const request = require('request');
const config = require('./config');

const getFiliais = (token) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '642e92efb79421734881b53e1e1b18b6'
        },
        uri: `${config.API_NODE}/orders/deliveryPlace`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getSuppliers = (token) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '3416a75f4cea9109507cacd8e2f2aefc'
        },
        uri: `${config.API_NODE}/suppliers`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getPedidos = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '3416a75f4cea9109507cacd8e2f2aefc'
        },
        uri: `${config.API_NODE}/orders`,
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getCondicoesPagamento = (token) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '3416a75f4cea9109507cacd8e2f2aefc'
        },
        uri: `${config.API_NODE}/paymentConditions`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const paymentConditionsList = (token, personId) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '3416a75f4cea9109507cacd8e2f2aefc'
        },
        uri: `${config.API_NODE}/orders/paymentConditionsList?personId=${personId}`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getMotivo = (token) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '67c6a1e7ce56d3d6fa748ab6d9af3fd7'
        },
        uri: `${config.API_NODE}/orders/reasons`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getQtdPen = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': 'a1d0c6e83f027327d8461063f4ac58a6'
        },
        uri: `${config.API_NODE}/orders/quantityPending`,
        method: 'GET',
        timeout: 3000,
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const postConfirmRefuse = (token, body) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '67c6a1e7ce56d3d6fa748ab6d9af3fd7'
        },
        uri: `${config.API_NODE}/orders/confirmRefuse`,
        method: 'POST',
        body: JSON.stringify(body)
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const postConfirmRefuseByList = (token, body) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: config.API_TOKEN,
          'x-api-key': config.GATEWAY_API_KEY,
          'usertoken': token,
          'userfunctionkey': '67c6a1e7ce56d3d6fa748ab6d9af3fd7'
        },
        uri: `${config.API_NODE}/orders/confirmRefuseByList`,
        method: 'POST',
        body: JSON.stringify(body)
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getDatasEntregas = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: `${config.URL_BACKEND}/gerenciarPedidos/dataEntrega`,
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

const getPedidosConcluidos = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: `${config.URL_BACKEND}/gerenciarPedidos/concluidos`,
        method: 'GET',
        qs: filters
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

function getEtiquetas({ token, params, body }) {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: `${config.URL_BACKEND}/etiqueta`,
        method: 'POST',
        qs: params,
        body
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
}

module.exports = {
  getCondicoesPagamento,
  getDatasEntregas,
  getEtiquetas,
  getFiliais,
  getMotivo,
  getPedidos,
  getPedidosConcluidos,
  getQtdPen,
  postConfirmRefuse,
  postConfirmRefuseByList,
  paymentConditionsList,
  getSuppliers
};
